import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import {
  ButtonComponent,
  EmptyPlaceholderActionsDirective,
  EmptyPlaceholderComponent,
} from '@catch/general-ui';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'app-platform-jobs-empty-state',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonComponent,
    EmptyPlaceholderActionsDirective,
    EmptyPlaceholderComponent,
  ],
  template: `
    <div class="ct-card empty-card">
      <ct-lib-empty-placeholder [icon]="icon()" [title]="title()" [text]="text()">
        <div emptyPlaceholderActions>
          <app-button
            variant="primary"
            [iconStart]="ctaIcon()"
            [routerLink]="ctaLink() ?? undefined"
            (click)="ctaClick.emit()"
          >
            {{ ctaLabel() }}
          </app-button>
          @if (secondaryCtaLabel()) {
            <app-button
              variant="white-grey"
              [iconStart]="secondaryCtaIcon()"
              [routerLink]="secondaryCtaLink() ?? undefined"
              [routerLinkActiveOptions]="{ exact: true }"
              (click)="secondaryCtaClick.emit()"
            >
              {{ secondaryCtaLabel() }}
            </app-button>
          }
        </div>
      </ct-lib-empty-placeholder>
    </div>
  `,
  styles: `
    :host {
      display: block;
    }

    .empty-card {
      padding: 1rem;
    }

    [emptyPlaceholderActions] {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      gap: 0.75rem;
    }
  `,
})
export class PlatformJobsEmptyStateComponent {
  readonly icon = input.required<IconProp>();
  readonly title = input.required<string>();
  readonly text = input.required<string>();
  readonly ctaLabel = input.required<string>();
  readonly ctaIcon = input.required<IconProp>();
  readonly ctaLink = input<readonly string[] | null>(null);
  readonly ctaClick = output<void>();
  readonly secondaryCtaLabel = input<string | null>(null);
  readonly secondaryCtaIcon = input<IconProp | undefined>(undefined);
  readonly secondaryCtaLink = input<readonly string[] | null>(null);
  readonly secondaryCtaClick = output<void>();
}
